'use strict';

exports.__esModule = true;

var _withDragAndDrop = require('./withDragAndDrop');

var _withDragAndDrop2 = _interopRequireDefault(_withDragAndDrop);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _withDragAndDrop2.default;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-big-calendar/lib/addons/dragAndDrop/index.js
// module id = 991
// module chunks = 1